// 受检人年龄单位类型
export let methods = [
  {
    label: '生活饮用水标准检验方法 有机物综合指标 ',
    value: 'GB/T 5750.7-2006 （1.1）'
  },
  {
    label: '生活饮用水标准检验方法 无机非金属指标 ',
    value: 'GB/T 5750.5-2006'
  }
]